import { connectedStore } from '../../store';
import getGlobalsToUpdate from './get-globals-to-update';
import hasSameGlobal from '../verifiers/has-same-global';
import { UPDATE_STATIC_ONLY, UPDATE_BOTH } from '../../hdrm/constants/update-strategies';

const globalActionExtender = (action) => {
  const store = connectedStore.get();
  const state = store.getState();
  const globalsToUpdate = getGlobalsToUpdate(state, action);
  const { options: initialOptions = {} } = action.payload;
  const { strategy: initialStrategy = UPDATE_BOTH } = initialOptions;
  const options = {
    ...initialOptions,
    strategy: globalsToUpdate.some(hasSameGlobal) ? UPDATE_STATIC_ONLY : initialStrategy,
  };

  return {
    ...action,
    payload: {
      ...action.payload,
      globalsToUpdate,
      options,
    },
  };
};

export default globalActionExtender;
